// Feature-Schalter für die Webinar-Ansichten (Audience, Dozent, Admin, SuperAdmin).

// Teilnehmer per Kamera/Mikro live zuschalten ("live schalten" beim Dozenten,
// videoOn/videoOff bei der Audience). Aktuell nicht mehr genutzt: die Audience
// schaut nur zu und stellt Fragen. Code bleibt drin – auf true setzen reaktiviert alles.
export const AUDIENCE_LIVE_ENABLED = false;
